import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { SkillEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';
import styled from 'styled-components';

import { DolLogo } from '@doltech/ui/lib/figma/DolLogo';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { flexGap } from '@doltech/utils/lib/css-style';
import { ListeningReviewTimeLimit } from '../../../../components/TimeLimit/ListeningReviewTimeLimit';
import { TimeLimit } from '../../../../components/TimeLimit/TimeLimit';

export const HEADER_HEIGHT_DO_TEST_DESKTOP = 68;

interface DoTestHeaderDesktopProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  showQuitButton?: boolean;
  isViewResult?: boolean;
  skill?: SkillEnum;
  isReviewing?: boolean;
  testName?: string;
  onQuit?: () => void;
}

const Main = styled.div`
  width: 100%;
  background-color: ${colorsV2.white100};
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.04), 4px 0 2px rgba(0, 0, 0, 0.06),
    4px 0 1px rgba(0, 0, 0, 0.04);
  z-index: 1;
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 232px) minmax(0, 1fr) minmax(0, 232px);
  align-items: center;
  gap: 16px;
  padding: 8px 24px;
  height: ${HEADER_HEIGHT_DO_TEST_DESKTOP}px;
`;

const TestInfo = styled.div`
  text-align: center;
`;

const Timer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  ${flexGap(16)}
`;

const LogoWrapper = styled.div``;

export const DoTestHeaderDesktop = (props: DoTestHeaderDesktopProps) => {
  const {
    text,
    showQuitButton = true,
    onQuit,
    className,
    isViewResult = false,
    skill,
    testName,
    isReviewing = false,
  } = props;

  const renderTimeLimit = React.useCallback(() => {
    if (isViewResult) {
      return '';
    }
    if (skill === SkillEnum.LISTENING && isReviewing) {
      return <ListeningReviewTimeLimit />;
    }
    return <TimeLimit />;
  }, [isReviewing, isViewResult, skill]);

  return (
    <Main className={className}>
      <LogoWrapper>
        <DolLogo />
      </LogoWrapper>
      <TestInfo>
        <ResponsiveTypography.Paragraph variant="bold/16-24" color="gray180">
          {text}
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="gray140">
          {testName}
        </ResponsiveTypography.Paragraph>
      </TestInfo>
      <Timer>
        {renderTimeLimit()}
        {showQuitButton && (
          <Button.Icon size="medium" onClick={onQuit}>
            <IconOtherClose />
          </Button.Icon>
        )}
      </Timer>
    </Main>
  );
};
